import {catalogItemMediaStackMq} from '../../../../../../utils/compositionMediaUtils';
import {technicalMapCardFieldsInlineMq, technicalMapMobileMq} from './technicalMapBreakpoints';

const catalogItemNarrowMq = '@media (max-width: 1023px)';
const catalogTab1FieldsCompactMq = '@media (max-width: 700px)';

export const technicalMapCardSectionTitleSx = {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.3,
    [catalogItemNarrowMq]: {
        fontSize: '20px',
    },
    [catalogTab1FieldsCompactMq]: {
        fontSize: '18px',
    },
};

export const technicalMapCardFieldRowSx = {
    backgroundColor: 'inherit',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '100%',
    padding: '8px 12px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    [catalogItemMediaStackMq]: {
        padding: '6px 8px',
        minHeight: '36px',
    },
    [catalogItemNarrowMq]: {
        padding: '2px 4px',
    },
    [technicalMapMobileMq]: {
        padding: '4px 4px',
        minHeight: '32px',
    },
    [technicalMapCardFieldsInlineMq]: {
        display: 'none',
    },
};

export const technicalMapCardFieldInlineRowSx = {
    display: 'none',
    width: '100%',
    boxSizing: 'border-box',
    padding: '6px 12px',
    fontSize: '16px',
    lineHeight: 1.4,
    color: (theme) => theme.palette.text.primary,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    [technicalMapCardFieldsInlineMq]: {
        display: 'block',
        padding: '4px 4px',
        lineHeight: 1.3,
    },
};

export const technicalMapCardFieldInlineLabelSx = {
    fontWeight: 600,
};

export const technicalMapGroupedFieldInlineRowSx = {
    ...technicalMapCardFieldInlineRowSx,
    [technicalMapCardFieldsInlineMq]: {
        display: 'block',
        padding: '3px 4px',
        lineHeight: 1.3,
    },
};

export const technicalMapCardFieldLabelCellSx = {
    flex: '0 0 30%',
    width: '30%',
    maxWidth: '30%',
    minWidth: '108px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    overflow: 'hidden',
    borderRight: '1px solid #EAEBEA',
    paddingRight: '12px',
    boxSizing: 'border-box',
    [catalogItemMediaStackMq]: {
        paddingRight: '8px',
    },
    [catalogItemNarrowMq]: {
        paddingRight: '4px',
    },
    [technicalMapMobileMq]: {
        paddingRight: '4px',
    },
};

export const technicalMapCardFieldValueCellSx = {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    padding: '0 12px',
    boxSizing: 'border-box',
    [catalogItemMediaStackMq]: {
        padding: '0 8px',
    },
    [catalogItemNarrowMq]: {
        padding: '0 4px',
    },
    [technicalMapMobileMq]: {
        padding: '0 4px',
    },
};

export const technicalMapCardFieldLabelSx = {
    fontSize: '16px',
    fontWeight: 600,
    minWidth: 0,
    width: '100%',
    lineHeight: 1.3,
    color: (theme) => theme.palette.text.primary,
    [catalogItemMediaStackMq]: {
        fontSize: '14px',
    },
    [catalogItemNarrowMq]: {
        fontSize: '16px',
    },
    [catalogTab1FieldsCompactMq]: {
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
    },
};

export const technicalMapCardFieldValueSx = {
    fontSize: '16px',
    fontWeight: 400,
    minWidth: 0,
    width: '100%',
    lineHeight: 1.3,
    color: (theme) => theme.palette.text.primary,
    [catalogItemMediaStackMq]: {
        fontSize: '14px',
    },
    [catalogItemNarrowMq]: {
        fontSize: '16px',
    },
    [catalogTab1FieldsCompactMq]: {
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
    },
};

export const technicalMapCardWorkerNameSx = {
    fontSize: '16px',
    fontWeight: 400,
    minWidth: 0,
    width: '100%',
    lineHeight: 1.3,
    color: (theme) => theme.palette.text.primary,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
};

export const technicalMapCardWorkerRowSx = {
    backgroundColor: 'inherit',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '100%',
    padding: '8px 12px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: '40px',
    [catalogItemMediaStackMq]: {
        padding: '6px 8px',
        minHeight: '36px',
    },
    [catalogItemNarrowMq]: {
        padding: '2px 4px',
    },
};

export const technicalMapCardWorkersEmptySx = {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.3,
    py: 1.5,
    px: 1,
    textAlign: 'center',
    color: 'text.secondary',
};

export const technicalMapCardWorkerValueCellSx = {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    padding: 0,
    boxSizing: 'border-box',
};

export const technicalMapGroupContainerSx = {
    border: '1px solid #EAEBEA',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: 'white',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
};

export const technicalMapGroupHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    px: '12px',
    py: '10px',
    backgroundColor: '#F5F6FA',
    borderBottom: '1px solid #EAEBEA',
    cursor: 'pointer',
    userSelect: 'none',
    [technicalMapMobileMq]: {
        px: '4px',
        py: '6px',
        gap: 0.5,
    },
};

export const technicalMapGroupBodySx = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: '10px',
    backgroundColor: '#F8F9FB',
    [technicalMapMobileMq]: {
        gap: 0.5,
        px: '4px',
        py: '6px',
    },
};

export const technicalMapGroupedCardSx = {
    border: '1px solid #E3E5EA',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: 'white',
    boxShadow: 'none',
};

export const technicalMapGroupedFieldRowSx = {
    ...technicalMapCardFieldRowSx,
    minHeight: '32px',
    padding: '4px 8px',
    [technicalMapMobileMq]: {
        minHeight: '28px',
        padding: '3px 4px',
    },
};

export const technicalMapGroupedFieldLabelSx = {
    ...technicalMapCardFieldLabelSx,
    fontSize: '14px',
};

export const technicalMapGroupedFieldValueSx = {
    ...technicalMapCardFieldValueSx,
    fontSize: '14px',
};
